// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { deviceId } from './Device';
import { operatorId } from './Operator';
import { z } from 'zod';
export const deviceParameterizeFitId = (z.number());
export const deviceParameterizeFit = z.object({
    id: deviceParameterizeFitId,
    device_id: deviceId,
    affordance_key: z.string(),
    data_points: z.unknown(),
    fitted_params: z.unknown(),
    r_squared: z.number().nullable(),
    created_at: z.date(),
    updated_at: z.date(),
    created_by: operatorId.nullable(),
    last_updated_by: operatorId.nullable(),
});
export const deviceParameterizeFitInitializer = z.object({
    id: deviceParameterizeFitId.optional(),
    device_id: deviceId,
    affordance_key: z.string(),
    data_points: z.unknown(),
    fitted_params: z.unknown(),
    r_squared: z.number().optional().nullable(),
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
    created_by: operatorId.optional().nullable(),
    last_updated_by: operatorId.optional().nullable(),
});
export const deviceParameterizeFitMutator = z.object({
    id: deviceParameterizeFitId.optional(),
    device_id: deviceId.optional(),
    affordance_key: z.string().optional(),
    data_points: z.unknown().optional(),
    fitted_params: z.unknown().optional(),
    r_squared: z.number().optional().nullable(),
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
    created_by: operatorId.optional().nullable(),
    last_updated_by: operatorId.optional().nullable(),
});
//# sourceMappingURL=DeviceParameterizeFit.js.map